export const blogs1 = [
  {
    id: 1,
    delay: "0.1s",
    imgSrc: "/assets/images/blog/post-prev-1.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImg: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 2,
    delay: "0.2s",
    imgSrc: "/assets/images/blog/post-prev-2.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImg: "/assets/images/blog/author/author-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 3,
    delay: "0.3s",
    imgSrc: "/assets/images/blog/post-prev-3.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImg: "/assets/images/blog/author/author-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
];

export const blogs2 = [
  {
    id: 4,
    imgSrc: "/assets/images/demo-modern/blog/1.jpg",
    title: "Natura Insects Series: Crafting Insects Made by Flowers",
    date: "December 3, 2023",
    rellaxSpeed: -1,
    rellaxPercentage: 0.37,
  },
  {
    id: 5,
    imgSrc: "/assets/images/demo-modern/blog/2.jpg",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 2, 2023",
  },
  {
    id: 6,
    imgSrc: "/assets/images/demo-modern/blog/3.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    date: "November 29, 2023",
    rellaxSpeed: 1,
    rellaxPercentage: 0.37,
  },
];

export const blogs3 = [
  {
    id: 7,
    imgSrc: "/assets/images/demo-brutalist/blog/1.jpg",
    alt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Natura Insects Series: Crafting Insects Made by Flowers",
    delay: "",
  },
  {
    id: 8,
    imgSrc: "/assets/images/demo-brutalist/blog/2.jpg",
    alt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Minimalistic Design Concept for Balmain Online Store",
    delay: "0.2s",
  },
  {
    id: 9,
    imgSrc: "/assets/images/demo-brutalist/blog/3.jpg",
    alt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Stylish Newspaper Cover Illustration",
    delay: "0.4s",
  },
];

export const blogs4 = [
  {
    id: 10,
    imageUrl: "/assets/images/demo-corporate/blog/post-prev-1.jpg",
    title: "Content Marketing Steps That Will Help You to Grow Your Business",
    description:
      "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
    date: "February 13, 2022",
    category: "Articles",
    colorClass: "color-primary-1",
  },
  {
    id: 11,
    imageUrl: "/assets/images/demo-corporate/blog/post-prev-2.jpg",
    title: "Top Five Trends for Small Investment Companies Marketing",
    description:
      "The micro-environment, over which a firm holds a greater amount control, typically includes Employees, Suppliers and the Media.",
    date: "February 11, 2023",
    category: "Tutorials",
    colorClass: "color-primary-2",
  },
];

// Legacy blog data - now using blogPosts.js for bilingual support
// This file is kept for backward compatibility with other components

export const blogs5 = []; // Empty array - components should use getBlogPostsByLanguage() instead

export const blogs6 = [
  {
    id: 15,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-1.jpg",
    imgAlt: "Add Image Description",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/demo-fancy/user-1.jpg",
    authorImgAlt: "Image Description",
    author: "Adam Smith",
    date: "August 3",
    delay: "0s",
  },
  {
    id: 16,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-2.jpg",
    imgAlt: "Add Image Description",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImgSrc: "/assets/images/demo-fancy/user-2.jpg",
    authorImgAlt: "Image Description",
    author: "Emma Kandel",
    date: "August 2",
    delay: "0.1s",
  },
  {
    id: 17,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-3.jpg",
    imgAlt: "Add Image Description",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImgSrc: "/assets/images/demo-fancy/user-3.jpg",
    authorImgAlt: "Image Description",
    author: "Thomas Johnson",
    date: "August 1",
    delay: "0.2s",
  },
];

export const blogs7 = [
  {
    id: 18,
    imgSrc: "/assets/images/demo-gradient/blog/post-prev-1.jpg",
    imgAlt: "Add Image Description",
    postTitle: "Elegant Branding Work for Red Circle by Oddone",
    postText:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImgSrc: "/assets/images/demo-gradient/user-1.jpg",
    authorName: "Thomas Johnson",
    postDate: "August 3",
  },
  {
    id: 19,
    imgSrc: "/assets/images/demo-gradient/blog/post-prev-2.jpg",
    imgAlt: "Add Image Description",
    postTitle: "Random Explorations with Cinema 4D and Redshift",
    postText:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImgSrc: "/assets/images/demo-gradient/user-2.jpg",
    authorName: "Adam Smith",
    postDate: "August 3",
  },
];

export const blogs8 = [
  {
    id: 20,
    imageSrc: "/assets/images/demo-modern/blog/1.jpg",
    title: "Natura Insects Series: Crafting Insects Made by Flowers",
    date: "December 3, 2023",
    rellaxY: "",
    rellaxSpeed: -1,
    rellaxPercentage: "0.37",
  },
  {
    id: 21,
    imageSrc: "/assets/images/demo-modern/blog/2.jpg",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 2, 2023",
    rellaxY: "",
    rellaxSpeed: 0,
    rellaxPercentage: "",
  },
  {
    id: 22,
    imageSrc: "/assets/images/demo-modern/blog/3.jpg",
    title: "Stylish Newspaper Cover Illustration",
    date: "November 29, 2023",
    rellaxY: "",
    rellaxSpeed: 1,
    rellaxPercentage: "0.37",
  },
];

export const blogs9 = [
  {
    id: 23,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-1.jpg",
    altText: "Add Image Description",
    title: "Elegant Branding Work for Red Circle by Oddone",
    intro:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImgSrc: "/assets/images/demo-slick/user-1.jpg",
    authorName: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 24,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-2.jpg",
    altText: "Add Image Description",
    title: "Random Explorations with Cinema 4D and Redshift",
    intro:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImgSrc: "/assets/images/demo-slick/user-2.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
];

export const blogs10 = [
  {
    id: 25,
    imgSrc: "/assets/images/demo-modern/blog/1.jpg",
    imgAlt: "Image Description",
    title: "Natura Insects Series: Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 26,
    imgSrc: "/assets/images/demo-modern/blog/2.jpg",
    imgAlt: "Image Description",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 27,
    imgSrc: "/assets/images/demo-modern/blog/3.jpg",
    imgAlt: "Image Description",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
  {
    id: 28,
    imgSrc: "/assets/images/demo-modern/blog/5.jpg",
    imgAlt: "Image Description",
    title: "Revitalizing Grenier brand identity and editorial design",
    date: "December 3, 2023",
  },
  {
    id: 29,
    imgSrc: "/assets/images/demo-modern/blog/6.jpg",
    imgAlt: "Image Description",
    title: "Athletics unveils vibrant branding project for MLS GO",
    date: "December 3, 2023",
  },
  {
    id: 30,
    imgSrc: "/assets/images/demo-modern/blog/4.jpg",
    imgAlt: "Image Description",
    title: "Manyway: a humanized global transaction experience",
    date: "December 3, 2023",
  },
  {
    id: 31,
    imgSrc: "/assets/images/demo-modern/blog/7.jpg",
    imgAlt: "Image Description",
    title: "Natura Insects Series: Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 32,
    imgSrc: "/assets/images/demo-modern/blog/8.jpg",
    imgAlt: "Image Description",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 33,
    imgSrc: "/assets/images/demo-modern/blog/9.jpg",
    imgAlt: "Image Description",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
];

export const blogs11 = [
  {
    id: 34,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-1.jpg",
    title: "Elegant Branding Work for Red Circle by Oddone",
    text: "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 35,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-2.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 36,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-3.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 37,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-4.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 38,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-5.jpg",
    title: "Strand man — an abstract 3D portrait series",
    text: "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 39,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-6.jpg",
    title: "Design & 3D Motion Campaign for Tylko",
    text: "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 40,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-7.jpg",
    title: "Elegant Branding Work for Red Circle by Oddone",
    text: "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 41,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-8.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
];
export const blogs12 = [
  {
    id: 42,
    imgSrc: "/assets/images/demo-modern/blog/1.jpg",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 43,
    imgSrc: "/assets/images/demo-modern/blog/2.jpg",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 44,
    imgSrc: "/assets/images/demo-modern/blog/3.jpg",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
  {
    id: 45,
    imgSrc: "/assets/images/demo-modern/blog/5.jpg",
    title: "Revitalizing Grenier brand identity and editorial design",
    date: "December 3, 2023",
  },
  {
    id: 46,
    imgSrc: "/assets/images/demo-modern/blog/6.jpg",
    title: "Athletics unveils vibrant branding project for MLS GO",
    date: "December 3, 2023",
  },
  {
    id: 47,
    imgSrc: "/assets/images/demo-modern/blog/4.jpg",
    title: "Manyway a humanized global transaction experience",
    date: "December 3, 2023",
  },
  {
    id: 48,
    imgSrc: "/assets/images/demo-modern/blog/7.jpg",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 49,
    imgSrc: "/assets/images/demo-modern/blog/8.jpg",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 50,
    imgSrc: "/assets/images/demo-modern/blog/9.jpg",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
];

export const blogs13 = [
  {
    id: 51,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-1.jpg",
    title: "Elegant Branding Work for Red Circle by Oddone",
    description:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 52,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-2.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    description:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 53,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-3.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    description:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 54,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-4.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    description:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 55,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-5.jpg",
    title: "Strand man — an abstract 3D portrait series",
    description:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 56,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-6.jpg",
    title: "Design & 3D Motion Campaign for Tylko",
    description:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
  {
    id: 57,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-7.jpg",
    title: "Elegant Branding Work for Red Circle by Oddone",
    description:
      "Oddone and brand strategist, Caren Williams, worked together with the San Francisco-based startup...",
    authorImg: "/assets/images/demo-slick/user-1.jpg",
    author: "Thomas Johnson",
    date: "August 3",
  },
  {
    id: 58,
    imgSrc: "/assets/images/demo-slick/blog/post-prev-8.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    description:
      "Nidia Dias is a 3D designer based in Portugal with an incredible portfolio. From the professional...",
    authorImg: "/assets/images/demo-slick/user-2.jpg",
    author: "Adam Smith",
    date: "August 3",
  },
];
export const blogs14 = [
  {
    id: 59,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-1.jpg",
    imgAlt: "Add Image Description",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImg: "/assets/images/demo-fancy/user-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 60,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-2.jpg",
    imgAlt: "Add Image Description",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImg: "/assets/images/demo-fancy/user-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 61,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-3.jpg",
    imgAlt: "Add Image Description",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImg: "/assets/images/demo-fancy/user-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
  {
    id: 62,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-4.jpg",
    imgAlt: "Add Image Description",
    title: "Strand man — an abstract 3D portrait series",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImg: "/assets/images/demo-fancy/user-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
  {
    id: 63,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-5.jpg",
    imgAlt: "Add Image Description",
    title: "Design & 3D Motion Campaign for Tylko",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImg: "/assets/images/demo-fancy/user-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 64,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-6.jpg",
    imgAlt: "Add Image Description",
    title: "Unveiling the branding and visual Identity of Merkezsiz",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImg: "/assets/images/demo-fancy/user-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 65,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-7.jpg",
    imgAlt: "Add Image Description",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImg: "/assets/images/demo-fancy/user-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 66,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-8.jpg",
    imgAlt: "Add Image Description",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImg: "/assets/images/demo-fancy/user-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 67,
    imgSrc: "/assets/images/demo-fancy/blog/post-prev-9.jpg",
    imgAlt: "Add Image Description",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImg: "/assets/images/demo-fancy/user-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
];
export const blogs15 = [
  {
    id: 68,
    imgSrc: "/assets/images/demo-elegant/blog/1.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 69,
    imgSrc: "/assets/images/demo-elegant/blog/2.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 70,
    imgSrc: "/assets/images/demo-elegant/blog/3.jpg",
    title: "Visually Identity & Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 71,
    imgSrc: "/assets/images/demo-elegant/blog/4.jpg",
    title: "Design & 3D Motion Campaign for Tylko",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 72,
    imgSrc: "/assets/images/demo-elegant/blog/5.jpg",
    title: "Unveiling the branding and visual Identity of Merkezsiz",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 73,
    imgSrc: "/assets/images/demo-elegant/blog/6.jpg",
    title: "Strand man — an abstract 3D portrait series",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 74,
    imgSrc: "/assets/images/demo-elegant/blog/9.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 75,
    imgSrc: "/assets/images/demo-elegant/blog/7.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    author: "Thomas Johnson",
    date: "August 5",
  },
  {
    id: 76,
    imgSrc: "/assets/images/demo-elegant/blog/8.jpg",
    title: "Visually Identity & Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    author: "Thomas Johnson",
    date: "August 5",
  },
];

export const blogs16 = [
  {
    id: 77,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-1.jpg",
    title: "Content Marketing Steps That Will Help You to Grow Your Business",
    date: "February 13, 2022",
    category: "Articles",
    colorClass: "color-primary-1",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 78,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-2.jpg",
    title: "Top Five Trends for Small Investment Companies Marketing",
    date: "February 11, 2023",
    category: "Tutorials",
    colorClass: "color-primary-2",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 79,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-3.jpg",
    title: "Powerful Content Marketing Strategies for Business Growth",
    date: "February 11, 2023",
    category: "Tutorials",
    colorClass: "color-primary-3",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 80,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-4.jpg",
    title: "Content Marketing Mastery Accelerating Your Business Success",
    date: "February 13, 2022",
    category: "Articles",
    colorClass: "color-primary-4",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 81,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-5.jpg",
    title: "Winning with Content Marketing Steps for Business Growth",
    date: "February 11, 2023",
    category: "Tutorials",
    colorClass: "color-primary-1",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 82,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-6.jpg",
    title: "From Content to Success Essential Business Growth Steps",
    date: "February 13, 2022",
    category: "Articles",
    colorClass: "color-primary-2",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 83,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-7.jpg",
    title: "Strategic Content Marketing for Expanding Your Business",
    date: "February 11, 2023",
    category: "Tutorials",
    colorClass: "color-primary-3",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
  {
    id: 84,
    imgUrl: "/assets/images/demo-corporate/blog/post-prev-8.jpg",
    title: "Content Marketing Unleashed Your Path to Business Growth",
    date: "February 13, 2022",
    category: "Articles",
    colorClass: "color-primary-4",
    desc: "The macro-environment, over which a firm holds little control, consists of a variety of external factors that manifest on a large scale.",
  },
];

export const widgetPosts = [
  {
    id: 85,
    imgUrl: "/assets/images/blog/previews/post-prev-1.jpg",
    title: "Minimalistic Design Forever",
    author: "John Doe",
  },
  {
    id: 86,
    imgUrl: "/assets/images/blog/previews/post-prev-2.jpg",
    title: "Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit",
    author: "John Doe",
  },
  {
    id: 87,
    imgUrl: "/assets/images/blog/previews/post-prev-3.jpg",
    title: "New Web Design Trends in 2023 Year",
    author: "John Doe",
  },
  {
    id: 88,
    imgUrl: "/assets/images/blog/previews/post-prev-4.jpg",
    title: "Hipster’s Style in Web Design and Logo",
    author: "John Doe",
  },
  {
    id: 89,
    imgUrl: "/assets/images/blog/previews/post-prev-5.jpg",
    title: "Duis Tristique Condimentum Nulla Bibendum Consectetu",
    author: "John Doe",
  },
];

export const blogs17 = [
  {
    id: 90,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/1.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
  },
  {
    id: 91,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/2.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Minimalistic Design Concept for Balmain Online Store",
  },
  {
    id: 92,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/3.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Stylish Newspaper Cover Illustration by Jack Johnson",
  },
  {
    id: 93,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/6.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
  },
  {
    id: 94,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/5.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
  },
  {
    id: 95,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/4.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Minimalistic Design Concept for Balmain Online Store",
  },
  {
    id: 96,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/7.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Stylish Newspaper Cover Illustration by Jack Johnson",
  },
  {
    id: 97,
    imgSrc: "/assets/images/demo-brutalist/blog/blog-2-col/8.jpg",
    imgAlt: "Image Description",
    author: "John Doe",
    date: "6 June",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
  },
];
export const blogs18 = [
  {
    id: 98,
    imgSrc: "/assets/images/demo-modern/blog/1.jpg",
    imgAlt: "Image Description",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 99,
    imgSrc: "/assets/images/demo-modern/blog/2.jpg",
    imgAlt: "Image Description",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 100,
    imgSrc: "/assets/images/demo-modern/blog/3.jpg",
    imgAlt: "Image Description",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
  {
    id: 101,
    imgSrc: "/assets/images/demo-modern/blog/5.jpg",
    imgAlt: "Image Description",
    title: "Revitalizing Grenier brand identity and editorial design",
    date: "December 3, 2023",
  },
  {
    id: 102,
    imgSrc: "/assets/images/demo-modern/blog/6.jpg",
    imgAlt: "Image Description",
    title: "Athletics unveils vibrant branding project for MLS GO",
    date: "December 3, 2023",
  },
  {
    id: 103,
    imgSrc: "/assets/images/demo-modern/blog/4.jpg",
    imgAlt: "Image Description",
    title: "Manyway a humanized global transaction experience",
    date: "December 3, 2023",
  },
  {
    id: 104,
    imgSrc: "/assets/images/demo-modern/blog/7.jpg",
    imgAlt: "Image Description",
    title: "Natura Insects Series Crafting Insects Made by Flowers",
    date: "December 3, 2023",
  },
  {
    id: 105,
    imgSrc: "/assets/images/demo-modern/blog/8.jpg",
    imgAlt: "Image Description",
    title: "Minimalistic Design Concept for Balmain Online Store",
    date: "December 3, 2023",
  },
  {
    id: 106,
    imgSrc: "/assets/images/demo-modern/blog/9.jpg",
    imgAlt: "Image Description",
    title: "Stylish Newspaper Cover Illustration by New York Design Band",
    date: "December 3, 2023",
  },
];

export const blogs19 = [
  {
    id: 107,
    imgSrc: "/assets/images/blog/post-prev-1.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 108,
    imgSrc: "/assets/images/blog/post-prev-2.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImgSrc: "/assets/images/blog/author/author-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 109,
    imgSrc: "/assets/images/blog/post-prev-3.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImgSrc: "/assets/images/blog/author/author-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
  {
    id: 110,
    imgSrc: "/assets/images/blog/post-prev-4.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 111,
    imgSrc: "/assets/images/blog/post-prev-5.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 112,
    imgSrc: "/assets/images/blog/post-prev-6.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImgSrc: "/assets/images/blog/author/author-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 113,
    imgSrc: "/assets/images/blog/post-prev-7.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImgSrc: "/assets/images/blog/author/author-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
  {
    id: 114,
    imgSrc: "/assets/images/blog/post-prev-8.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 115,
    imgSrc: "/assets/images/blog/post-prev-9.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
  {
    id: 116,
    imgSrc: "/assets/images/blog/post-prev-10.jpg",
    title: "Random Explorations with Cinema 4D and Redshift",
    text: "Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio. From the professional work done with...",
    authorImgSrc: "/assets/images/blog/author/author-2.jpg",
    authorName: "Emma Kandel",
    date: "August 2",
  },
  {
    id: 117,
    imgSrc: "/assets/images/blog/post-prev-11.jpg",
    title: "Visually Identity and Branding for Mexican Restaurant",
    text: "Anta Petrenco shared a beautiful visual identity, branding and packaging design project on their Behance profile...",
    authorImgSrc: "/assets/images/blog/author/author-3.jpg",
    authorName: "Thomas Johnson",
    date: "August 1",
  },
  {
    id: 118,
    imgSrc: "/assets/images/blog/post-prev-12.jpg",
    title: "Spotlight — Equinox Collection by Shane Griffin",
    text: "Looking for inspiration to kick it off, I stumbled across the work of Shane Griffin, an artist and director based in New York...",
    authorImgSrc: "/assets/images/blog/author/author-1.jpg",
    authorName: "Adam Smith",
    date: "August 3",
  },
];

export const allBlogs = [
  ...blogs1,
  ...blogs2,
  ...blogs3,
  ...blogs4,
  ...blogs5,
  ...blogs6,
  ...blogs7,
  ...blogs8,
  ...blogs9,
  ...blogs10,
  ...blogs11,
  ...blogs12,
  ...blogs13,
  ...blogs14,
  ...blogs15,
  ...blogs16,
  ...blogs17,
  ...blogs18,
  ...blogs19,
  ...widgetPosts,
];
